/**
 * Created by administrator on 2017/3/28.
 */
import NProgress from 'nprogress'
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { GetOrderAuditByPage, ERP_AuditOrder, GetOrderAuditStatistics } from '@api/orderApi';

//组件
import adoptDialog from './adoptDialog.vue';

module.exports = {
    components: {
        'adopt-dialog': adoptDialog
    },
    data() {
        return {
            AuditNum: [],
            Session: util.getSessin(),
            //发货状态
            querySort: [{ "SortName": "-请选择-", "SortValue": "-1" }, { "SortName": "未发货", "SortValue": "0" }, { "SortName": "部分发货", "SortValue": "1" }, { "SortName": "全部发货", "SortValue": "2" }],
            //收货状态
            queryType: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "待审核", "TypeValue": "0" }, { "TypeName": "审核通过", "TypeValue": "1" }, { "TypeName": "驳回", "TypeValue": "2" }, { "TypeName": "已作废", "TypeValue": "3" }],
            loading2: false,
            lists: [{ "Id": "346567788" }],
            pageIndex: 1,
            pageSize: 15,
            totalSize: '',
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [15, 20, 50],
            query: {
                OrderCode: "",
                AgentName: "",
                AreaName: "",
                OrderStatus: "",
                SendStatus: "",
                UserName: ""
            }

        }
    },
    methods: {
        //新增销售下单
        addOrder: function() {
            this.$router.push("/Order/SaleOrder/addOrder");
        },
        //初始化加载页面
        List() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            var para = this.getParams()
            GetOrderAuditByPage(para).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt)
                for (var i = 0; i < Data.length; i++) {
                    Data[i].AreaName = Data[i].AreaName.split("市")[0] + '市'
                    if (Data[i].AreaName == "北京北京市") {
                        Data[i].AreaName = "北京市"
                    }
                    if (Data[i].AreaName == "重庆重庆市") {
                        Data[i].AreaName = "重庆市"
                    }
                    if (Data[i].AreaName == "上海上海市") {
                        Data[i].AreaName = "上海市"
                    }
                    if (Data[i].AreaName == "天津天津市") {
                        Data[i].AreaName = "天津市"
                    }
                }
            });
        },
        //通用输入参数
        getParams: function() {
            var para = {
                Sid: this.Session[0],
                Session: this.Session[1],
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            if (this.query.OrderCode != '') {
                para.OrderCode = this.query.OrderCode
            }
            if (this.query.AgentName != '') {
                para.AgentName = this.query.AgentName
            }
            if (this.query.AreaName != '') {
                para.AreaName = this.query.AreaName
            }
            if (this.query.OrderStatus != '') {
                para.OrderStatus = this.query.OrderStatus
            }
            if (this.query.UserName != '') {
                para.UserName = this.query.UserName
            }
            return para
        },
        //通用提示信息
        outTips: function(StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false; //拼命加载中隐藏
                this.lists = Data;
            }
        },
        selsChange: function(sels) {
            this.sels = sels;
        },
        //查询
        onQuerySubmit: function() {
            this.pageIndex = 1;
            this.List();
        },
        //查询功能
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.List();
        },
        //通过
        adoptHandle: function(index, row) {
            if (row.OrderCode.indexOf("QY") > -1) {
                this.$refs.adoptDialog.show(row.OrderId, row.PayMode, row.SendMode);
                return;
            }

            this.$confirm('确认通过该订单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                NProgress.start();
                let para = {
                    OrderId: row.OrderId,
                    OrderStatus: 1,
                    Sid: this.Session[0],
                    Session: this.Session[1]
                };
                ERP_AuditOrder(para).then((response) => {
                    NProgress.done();
                    if (response.data.StateCode !== 0) {
                        this.$notify({
                            title: '错误',
                            message: response.data.StateMsg,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '审核通过成功',
                            type: 'success'
                        });
                        this.List();
                    }
                });
            }).catch(() => {

            });
        }, //退回
        ReturnHandle: function(index, row) {
            this.$confirm('确认驳回该订单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                NProgress.start();
                let para = {
                    OrderId: row.OrderId,
                    OrderStatus: 2,
                    Sid: this.Session[0],
                    Session: this.Session[1]
                };
                ERP_AuditOrder(para).then((response) => {
                    NProgress.done();
                    if (response.data.StateCode !== 0) {
                        this.$notify({
                            title: '错误',
                            message: response.data.StateMsg,
                            type: 'error'
                        });
                    } else {
                        this.$notify({
                            title: '成功',
                            message: '驳回成功',
                            type: 'success'
                        });
                        this.List();
                    }
                });
            }).catch(() => {

            });
        }

        , //编辑功能
        onQueryClean: function() {
            this.query.OrderCode = "";
            this.query.AgentName = "";
            this.query.AreaName = "";
            this.query.OrderStatus = "";
            this.query.SendStatus = "";
            this.query.UserName = "";
            this.List();
        },
        //删除
        handleDel: function() {
            var ids = this.sels.map(item => item.OrderId).toString();
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有选择删除内容',
                    type: 'warning'
                })
                return
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    NProgress.start();
                    let para = { Ids: ids };
                    ERP_OrderDel(para).then((response) => {
                        NProgress.done();
                        if (response.data.StateCode !== 0) {
                            this.$notify({
                                title: '错误',
                                message: response.data.StateMsg,
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success'
                            });
                            this.List();
                        }
                    });
                }).catch(() => {

                });

            }
        },
        //下载文件
        download: function() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                this.List();
                var para = this.getParams()
                GetOrderExport(para).then(res => {
                    util.doResult(this, res, () => {});
                    let { StateCode, StateMsg, Data, Cnt } = res.data;
                    if (StateCode !== 0 && StateCode !== 99) {
                        this.$notify({
                            title: '错误',
                            message: StateMsg,
                            type: 'error'
                        });
                    } else {

                        try {

                            var elemIF = document.createElement("iframe");
                            elemIF.src = Data;
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        } catch (e) {
                            this.$notify({
                                title: '浏览器不兼容，建议使用谷歌浏览器',
                                type: 'error'
                            });
                        }
                    }
                });

            })
        }, //导出功能
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.List();
            /* this.lists=[];
             this.loading2=true;//拼命加载中显示
             var para = this.getParams()
             GetOrderAuditByPage(para).then(res => {
                 let { StateCode, StateMsg, Data, Cnt } = res.data;
                 this.outTips(StateCode,StateMsg,Data,Cnt)
             });*/
        },
        ViewOrder2: function(index, item) {
            util.redirect(this, '/Order/AuditViewOrder?Id=' + item.OrderId, true);
        },
    },
    created() {
        this.List();
        let _session = util.getSessin();
        let para = {
            Sid: _session[0],
            Session: _session[1],
        };
        GetOrderAuditStatistics(para).then(res => {
            util.doResult(this, res, () => {
                this.AuditNum = res.data.Data;
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/Order/OrderControl.js